import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Actions
import { getAuthResources } from '../actions/auth'

export default function (ComposedComponent) {
  class Authenticate extends Component {

    componentWillMount () {
      if (!this.props.isAuthenticated) {
        this.props.router.push('/login')
      } else {
        // Get auth resources
        if (Object.keys(this.props.auth.permissions).length === 0) {
          this.props.getAuthResources()
        }
      }
    }

    componentWillUpdate (nextProps) {
      if (!nextProps.isAuthenticated) {
        this.props.router.push('/login')
      } else {
        setTimeout(() => {
          // Get auth resources
          if (Object.keys(this.props.auth.permissions).length === 0) {
            this.props.getAuthResources()
          }
        }, 1000)
      }
    }

    render () {
      return (
        <ComposedComponent {...this.props} />
      )
    }

  }

  Authenticate.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    getAuthResources: PropTypes.func.isRequired
  }

  function mapStateToProps (state) {
    return {
      auth: state.auth,
      isAuthenticated: state.auth.isAuthenticated
    }
  }

  return connect(mapStateToProps, {
    getAuthResources
  })(Authenticate)
}



// WEBPACK FOOTER //
// ./src/app/utils/requireAuth.js